import { useFormattedMessage } from "hooks";
import React from "react";
import Warning from "assets/images/svg/warning.svg";

const messages = {
    unable_to_load_list: "unable_to_load_list",
    unable_to_load_list_description: "unable_to_load_list_description",
    try_again: "try_again",
};

export default function RecordsLoadingError({ show = false, onClick }) {
    const { formatMessage } = useFormattedMessage();
    if (!show) {
        return null;
    }
    return (
        <div className="d-flex column align-center justify-end p-4 b-radius-2 border-1 my-5">
            <Warning style={{ width: 24, height: 24, marginBottom: 8 }} />
            <span className="text-16 mx-2 mb-2">{formatMessage(messages.unable_to_load_list)}</span>
            <span className="text-16 light-grey-color mb-2 mwp-70 text-center">
                {formatMessage(messages.unable_to_load_list_description)}
            </span>
            <button className="ml-4 b-radius-2 px-12 py-2 bg-dark mw-fit secondary text-16" onClick={() => onClick(true)}>
                {formatMessage(messages.try_again)}
            </button>
        </div>
    );
}
